import { Condition, CoreFileLog } from '../../models';
import http, { HttpSuccessOrErrorType, ListResults } from '../http';

export default {
    /**
     * core file打印日志
     * @param params 参数
     */
    async get_restaurant_core_file_log(params: { restaurant_string_id: string } & Condition): Promise<HttpSuccessOrErrorType<ListResults<CoreFileLog>[]>> {
        const { restaurant_string_id, ...rest } = params;
        return await http.get(`/core/restaurant/${restaurant_string_id}/core-file-log-by-admin`, {
            params: {
                ...rest
            }
        })
    },
}